import React, { PropsWithChildren } from 'react'

import { RTFBlockComponentProps, ParagraphBlockOptions } from '../../types'

import { paragraphBlock } from './index.module.scss'

type Props = RTFBlockComponentProps<ParagraphBlockOptions>

const ParagraphBlock = ({
  children,
  options,
  blockIndex,
}: PropsWithChildren<Props>) => {
  const hasDropCap = options?.withDropCap && blockIndex === 0

  return (
    <p className={paragraphBlock} data-drop-cap={hasDropCap}>
      {children}
    </p>
  )
}

export default ParagraphBlock
